import { z } from "zod";

export const ContactsSchema = z.array(
  z.object({
    name: z.string().nullish(),
    email: z.string().nullish(),
    phone: z.string().nullish(),
    type: z.string().nullish(),
  })
);

export type Contacts = z.infer<typeof ContactsSchema>;

export interface LazyOperationEntity<T> {
  value: T;
  operation: "create" | "update" | "delete" | "noop" | null;
}
